import * as z from 'zod';

export const shipSchema = z.object({
  name: z.string().nullable(),
  mmsi: z.string().nullable(),
  callSign: z.string().nullable(),
  imo: z.string().nullable(),
  type: z.string().nullable(),
});

export type Ship = z.infer<typeof shipSchema>;
